import React from 'react';
import { Typography } from '@/components/common';

interface Props {
	mismatchedLabels: string[];
}

export const ReviewMismatchBanner: React.FC<Props> = ({ mismatchedLabels }) => {
	if (mismatchedLabels.length === 0) return null;

	return (
		<div
			role="status"
			className="bg-amber-500/[0.08] border border-amber-500/30 rounded-2xl px-5 py-4"
		>
			<Typography type="semibold-14" className="!text-amber-700 !text-left">
				{mismatchedLabels.length === 1
					? 'A field does not match the recorded data.'
					: 'Some fields do not match the recorded data.'}
			</Typography>
			<Typography type="regular-12" className="!text-amber-600 pt-1 !text-left">
				Mismatched:{' '}
				<span className="font-semibold">{mismatchedLabels.join(', ')}</span>
			</Typography>
		</div>
	);
};
